export * from "./EXT_lights_image_based.js";
export * from "./EXT_mesh_gpu_instancing.js";
export * from "./EXT_meshopt_compression.js";
export * from "./EXT_texture_webp.js";
export * from "./KHR_draco_mesh_compression.js";
export * from "./KHR_lights_punctual.js";
export * from "./KHR_materials_pbrSpecularGlossiness.js";
export * from "./KHR_materials_unlit.js";
export * from "./KHR_materials_clearcoat.js";
export * from "./KHR_materials_iridescence.js";
export * from "./KHR_materials_emissive_strength.js";
export * from "./KHR_materials_sheen.js";
export * from "./KHR_materials_specular.js";
export * from "./KHR_materials_ior.js";
export * from "./KHR_materials_variants.js";
export * from "./KHR_materials_transmission.js";
export * from "./KHR_materials_translucency.js";
export * from "./KHR_materials_volume.js";
export * from "./KHR_mesh_quantization.js";
export * from "./KHR_texture_basisu.js";
export * from "./KHR_texture_transform.js";
export * from "./KHR_xmp_json_ld.js";
export * from "./KHR_animation_pointer.js";
export * from "./MSFT_audio_emitter.js";
export * from "./MSFT_lod.js";
export * from "./MSFT_minecraftMesh.js";
export * from "./MSFT_sRGBFactors.js";
export * from "./ExtrasAsMetadata.js";
//# sourceMappingURL=index.js.map